/**
 * Etichette in italiano degli stati e delle provenienze.
 *
 * Stanno in `lib/` e non accanto ai componenti per la stessa ragione dei toni
 * e del vocabolario dell'accessibilita': sono **dato di dominio**, non
 * componenti, e chi li legge non deve tirarsi dietro React.
 *
 * C'e' anche un effetto pratico immediato: un file che esporta sia componenti
 * sia costanti perde il Fast Refresh. Modificando il componente, Vite ricarica
 * l'intera pagina invece di sostituirlo a caldo, e con essa si perde lo stato
 * dei moduli — nel back-office, la sessione.
 *
 * Sono **una copia sola** di proposito. L'elenco delle pubblicazioni,
 * l'alberatura e la scheda di un nodo mostrano le stesse etichette, e due copie
 * della stessa parola divergono alla prima riformulazione.
 */

import type {
  NaturaObbligo,
  OriginePubblicazione,
  StatoPubblicazione,
} from "../api/types";

/** Etichette degli stati, come compaiono nella tabella del §6. */
export const ETICHETTA_STATO: Record<StatoPubblicazione, string> = {
  bozza: "Bozza",
  pubblicato: "Pubblicato",
  archiviato: "Archiviato",
};

/**
 * Etichette della provenienza di una bozza.
 *
 * «Da Amministrazione trasparente» e non «esterna»: il redattore deve sapere
 * *chi* ha proposto il contenuto, non che la riga arriva da fuori.
 */
export const ETICHETTA_ORIGINE: Record<OriginePubblicazione, string> = {
  interna: "Compilata qui",
  esterna: "Da Amministrazione trasparente",
};

/**
 * La natura di un obbligo, con cio' che comporta.
 *
 * La spiegazione sta nell'etichetta perche' la parola da sola non basta a
 * scegliere: chi dichiara la natura spegne una classe di allerte per sempre, e
 * deve leggere che cosa significa nel momento in cui la sceglie. La mostrano
 * sia la modale del verdetto sia quella della cadenza.
 */
export const ETICHETTA_NATURA: Record<NaturaObbligo, string> = {
  sostitutivo: "Sostitutivo — ogni periodo rimpiazza il precedente",
  accumulativo: "Accumulativo — i contenuti si sommano, un sostituto non esiste",
  non_ricorrente: "Non ricorrente — si valorizza quando l'evento accade",
};
